/*
 * Public API Surface of surf-generic-criteria
 */

export * from './lib/surf-generic-criteria.service';
export * from './lib/surf-generic-criteria.module';
export * from './lib/generic-criteria/generic-criteria.component';
export * from './lib/generic-criteria-dp/generic-criteria-dp.component';
